import React, {useEffect, useState} from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Row,
  Typography,
  notification,
} from "antd";
import type {TabsProps} from "antd";
import {HeaderPage, HistoryExamine, Tabs} from "components/common";
import Received from "./Received/Received";
import ReceiveNew from "./Receive/Receive";
import "./Receive.scss";
import ExtendCard from "./ExtendCard/ExtendCard";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import PatientCardManagement from "./PatientCardManagement/PatientCardManagement";
import ExaminationCard from "./ExaminationCard/ExaminationCard";
import {setActiveKey, setSiderKey} from "redux/reducer/common";
import {setPatientRecord} from "redux/reducer/patientRecord";
import ReportOPD from "./ReportOPD/ReportOPD";
import SignSecureNew from "pages/SignSecure/SignSecure";
import ConfigCatalog from "./ConfigCatalog/ConfigCatalog";

const Receive: React.FC = () => {
  const dispatch = useAppDispatch();
  const action = useAppSelector(state => state.receive);
  // const patientRecord = useAppSelector((state) => state.patientRecord);
  document.title = "Tiếp nhận";
  const items: TabsProps["items"] = [
    {
      key: tabKeys.RECEIVE.TAB_1,
      label: `Đã tiếp nhận`,
      children: <Received />,
    },
    {
      key: tabKeys.RECEIVE.TAB_2,
      label: `Tiếp nhận`,
      children: <ReceiveNew />,
      forceRender: true,
      disabled: action.dataPassing?.id ? false : true,
    },
    {
      key: tabKeys.RECEIVE.TAB_5,
      label: `Lịch sử khám bệnh`,
      children: <HistoryExamine />,
      disabled: action.dataPassing?.id ? false : true,
    },

    // {
    //   key: tabKeys.RECEIVE.TAB_3,
    //   label: `Gia hạn thẻ`,
    //   children: <ExtendCard />,
    //   disabled: patientRecord.selected ? false : true,
    // },
    {
      key: tabKeys.RECEIVE.TAB_6,
      label: "Mua thẻ khám bệnh",
      children: <ExaminationCard />,
      disabled: action.dataPassing?.id ? false : true,
    },
    {
      key: tabKeys.RECEIVE.TAB_4,
      label: `Quản lý danh sách thẻ`,
      children: <PatientCardManagement />,
    },
    {
      key: tabKeys.RECEIVE.REPORT,
      label: `Báo cáo OPD`,
      children: <ReportOPD />,
    },
    {
      key: tabKeys.RECEIVE.CONFIG_CATALOG,
      label: `Cấu hình tài khoản ký bảo mật`,
      children: <ConfigCatalog />,
    },
  ];
  const onTabClick = (key, event) => {
    dispatch(setActiveKey(key));
  };
  const activeTab = useAppSelector(state => state.common.activeTab);
  useEffect(() => {
    dispatch(setActiveKey(tabKeys.RECEIVE.TAB_1));
    // dispatch(setSiderKey("0"));
    dispatch(
      setPatientRecord({
        selected: false,
        record: null,
      })
    );
  }, []);

  return (
    <div className=" receive page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} onTabClick={onTabClick} />
      </div>
    </div>
  );
};
export default Receive;
